<dx-popup
  [width]="650"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'COMPLETE-TRAINING.SELECT-ADDITIONAL-PARTICIPANTS' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [(visible)]="showModal"
  class="modal"
  [classList]="'modal'"
  (onHiding)="onCancelClick()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="h-100">
      <div class="attendees-list">
        <dx-form [formData]="formData" labelMode="floating">
          <dxi-item>
            <dxo-label [text]="'COMMON.SEARCH' | translate"></dxo-label>
            <div *dxTemplate>
              <dx-text-box
                icon="search"
                width="100%"
                valueChangeEvent="input"
                labelMode="floating"
                stylingMode="outlined"
                placeholder=""
                [label]="
                  'MY-TRAININGS.TRAINING-INVITE.SEARCH-IN-EMPLOYEES-AND-CONTACTS'
                    | translate
                "
                [(value)]="formData.search"
                (valueChange)="onSerachValueChanged($event)"
              >
                <dxi-button
                  name="search"
                  type="danger"
                  location="before"
                  [options]="{
                    icon: 'search',
                    type: 'default',
                    disabled: true
                  }"
                ></dxi-button>
              </dx-text-box>
            </div>
          </dxi-item>
          <dxi-item itemType="group" colCount="2">
            <dxi-item>
              <dxo-label
                [text]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="formData.organisationUnitFilter"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
                  [dataSource]="organisationUnits"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="organisationUnits"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onOrganizationUnitsSelected($event)
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
            <dxi-item>
              <dxo-label
                [text]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="formData.trainingGroupFilter"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
                  [dataSource]="trainingGroups"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="trainingGroups"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onTrainingGroupSelected($event)
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>

        <dx-check-box
          class="all-attendees-checkbox"
          [value]="isAllSelected"
          [text]="'MY-TRAININGS.TRAINING-INVITE.ALL-EMPLOYEES' | translate"
          (click)="onAllEmployeesClick($event)"
        ></dx-check-box>
        <div class="available-list">
          <div class="list-wrapper" (scroll)="onScroll($event)">
            <div class="product" *ngFor="let person of allPersons; let i = index">
              <div class="info">
                <dx-check-box
                  [(value)]="person.selected"
                  (onValueChanged)="onPersonSelected($event, person)"
                ></dx-check-box>
                <div>
                  <div>{{ person.firstName }} {{ person.lastName }}</div>
                  <div class="email-muted">
                    {{ person.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="row">
          <div class="col">
            <div class="list-footer">
              <div>
                {{ "MY-TRAININGS.TRAINING-INVITE.TOTAL-SELECTED" | translate }}:
                <strong>{{ selectedPersons.length }}</strong>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="list-footer">
              <div>
                <dx-button
                  [disabled]="!selectedPersons.length"
                  [text]="'MY-TRAININGS.TRAINING-INVITE.DELETE-ALL' | translate"
                  type="default"
                  class="no-bg"
                  (click)="onRemoveClicked()"
                >
                </dx-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      stylingMode: 'contained',
      type: 'danger',
      text: 'COMMON.CANCEL' | translate,
      onClick: onCancelClick
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      type: 'normal',
      text: 'COMMON.ADD' | translate,
      onClick: onAddClick,
      disabled: isAddDisabled
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
